"use strict";Object.defineProperty(exports, "__esModule", {value: true});var _utils = require('shared/store/utils');
var _helpers = require('shared/actions/helpers');
var _store = require('shared/store');
var _user = require('shared/selectors/user');
var _pins = require('shared/services/pins');




























const getMeActions = _utils.createAsyncActions('GetMe')
const getInboxActions = _utils.createAsyncActions('GetInbox')
const getInboxCountsActions = _utils.createAsyncActions('GetInboxCounts')
const getInboxForUserActions = _utils.createAsyncActions('GetInboxForUser')
const getInboxForPatientActions = _utils.createAsyncActions('GetInboxForPatient')
const setTeamInboxSettingsActions = _utils.createAsyncActions('SetInboxableSettingsOnTeam')
const renameChatActions = _utils.createAsyncActions('ChangeBlobjectName')
const getBlobjectDeepActions = _utils.createAsyncActions('GetBlobjectByKeyDeep')
const updateChatNotificationsActions = _utils.createAsyncActions('SetNotificationSettingsOnBlobject')
const createConversationActions = _utils.createAsyncActions('CreateConversation')
const createSmsConversationActions = _utils.createAsyncActions('CreateSmsConversation')
const markBlobjectSeenActions = _utils.createAsyncActions('MarkBlobjectSeen')
const markBlobjectUnreadActions = _utils.createAsyncActions('MarkBlobjectUnread')
const setBlobjectPinnedActions = _utils.createAsyncActions('SetBlobjectPinned')
const completeBlobjectActions = _utils.createAsyncActions('CompleteBlobject')
const uncompleteBlobjectActions = _utils.createAsyncActions('UnCompleteBlobject')
const setBlobjectCompletedForTeamsActions = _utils.createAsyncActions('SetBlobjectCompletedForTeams')
const addParticipantsToChatActions = _utils.createAsyncActions('AddParticipantsToChat')
const removeParticipantsFromChatActions = _utils.createAsyncActions('RemoveParticipantsFromConversation')
const getBlobjectByWrappedKeyActions = _utils.createAsyncActions('GetBlobjectByWrappedKey')
const findReusableConversationActions = _utils.createAsyncActions('FindReusableConversation')
const createSupportTicketActions = _utils.createAsyncActions('CreateSupportTicket')

 const actionCreators = {
  getInboxActions,
  getInboxCountsActions,
  getInboxForUserActions,
  getInboxForPatientActions,
  setTeamInboxSettingsActions,
  renameChatActions,
  getMeActions,
  getBlobjectDeepActions,
  updateChatNotificationsActions,
  createConversationActions,
  markBlobjectSeenActions,
  markBlobjectUnreadActions,
  setBlobjectPinnedActions,
  completeBlobjectActions,
  uncompleteBlobjectActions,
  setBlobjectCompletedForTeamsActions,
  createSmsConversationActions,
  addParticipantsToChatActions,
  removeParticipantsFromChatActions,
  getBlobjectByWrappedKeyActions,
  findReusableConversationActions,
  createSupportTicketActions,
}; exports.actionCreators = actionCreators

// isWanted: see wsCommand. A stale answer is returned but not stored.
const getInbox = (req, isWanted) =>
  _helpers.wsCommand('GetInbox', getInboxActions, req, null, isWanted)

// Total chats, unread chats and mentions for several inbox lists in one round
// trip, e.g.
// [{ Id: 'mine/patients', WrappedTypes: ['patient_conversation', 'sms_patient_conversation'] },
//  { Id: 'mine/scheduled', ScheduledOnly: true },
//  { Id: 'support', TeamKey: supportTeamKey }].
const getInboxCounts = (queries) =>
  _helpers.wsCommand('GetInboxCounts', getInboxCountsActions, { Queries: queries }, null)

const setTeamInboxSettings = (req) =>
  _helpers.wsCommand(
    'SetInboxableSettingsOnTeam',
    setTeamInboxSettingsActions,
    req,
    null,
  )

// TODO: get rid of this mess.
const parseInboxResponse = (offset) =>
  (r) => {
    const blobjectsList = Object.values(r.Blobjects || {})
    return offset
      ? blobjectsList
      : blobjectsList
        .sort((a, b) =>
          (+new Date(b.InboxSortTime)) - (+new Date(a.InboxSortTime)),
        )
  }

const getInboxForUser = (
  { OrgKey, UserKey, Offset = 0, Limit = 30 },
) =>
  _helpers.wsCommand(
    'GetInboxForUser',
    getInboxForUserActions,
    { OrgKey, UserKey, Offset, Limit },
    null,
  )
    .then(parseInboxResponse(Offset))

const getInboxForPatient = (
  { PatientKey, Offset = 0, Limit = 30 },
) =>
  _helpers.wsCommand(
    'GetInboxForPatient',
    getInboxForPatientActions,
    { PatientKey, Offset, Limit },
    null,
  )
    .then(parseInboxResponse(Offset))

const renameChat = (req) =>
  _helpers.wsCommand('ChangeBlobjectName', renameChatActions, req, null)

const getMe = () => _helpers.wsCommand('GetMe', getMeActions, {}, null)

const getBlobjectDeep = (req) =>
  _helpers.wsCommand(
    'GetBlobjectByKeyDeep',
    getBlobjectDeepActions,
    req,
    null,
  )

const updateChatNotifications = (req) =>
  _helpers.wsCommand(
    "SetNotificationSettingsOnBlobject",
    updateChatNotificationsActions,
    req,
    null,
  )

const createConversation = (req) =>
  _helpers.wsCommand(
    "CreateConversation",
    createConversationActions,
    req,
    null,
  )

const createSmsConversation = (req) =>
  _helpers.wsCommand(
    'CreateSmsConversation',
    createSmsConversationActions,
    req,
    null,
  )

const markBlobjectSeen = (req) =>
  _helpers.wsCommand(
    'MarkBlobjectSeen',
    markBlobjectSeenActions,
    { BKey: req.BKey, SeenTime: req.SeenTime || new Date() },
    null,
  )

// Shown unread at once; the reducer turns it back on FAILURE (a rejection or
// no answer in time).
const markBlobjectUnread = (BKey) =>
  _helpers.wsCommand(
    'MarkBlobjectUnread',
    markBlobjectUnreadActions,
    { BKey },
    { BKey },
  )

// The pins in the store: every chat this client has loaded.
const countMyKnownPins = () => {
  const state = _store.getState.call(void 0, )
  const myUserKey = _user.selectCurrentUserKey.call(void 0, state)
  return Object.values(state.dataV2.blobjects).filter(b => !!b && _pins.isPinnedByMe.call(void 0, b, myUserKey)).length
}

// Previous is my current pin time, put back if the command fails.
const setBlobjectPinned = (BKey, Pinned, Previous) =>
  _helpers.wsCommand(
    'SetBlobjectPinned',
    setBlobjectPinnedActions,
    { BKey, Pinned },
    {
      BKey,
      PinnedAt: Pinned ? new Date().toISOString() : null,
      Previous,
      Optimistic: !Pinned || _pins.canPinOptimistically.call(void 0, countMyKnownPins()),
    },
  )

const completeBlobject = (BKey) =>
  _helpers.wsCommand(
    'CompleteBlobject',
    completeBlobjectActions,
    { BKey, UserKey: '' },
    { BKey },
  )

const uncompleteBlobject = (BKey) =>
  _helpers.wsCommand(
    'UnCompleteBlobject',
    uncompleteBlobjectActions,
    { BKey, UserKey: '' },
    { BKey },
  )

const setBlobjectCompletedForTeams = (req) =>
  _helpers.wsCommand(
    'SetBlobjectCompletedForTeams',
    setBlobjectCompletedForTeamsActions,
    req,
    null,
  )

const addParticipantsToChat = (req) =>
  _helpers.wsCommand(
    "AddParticipantsToConversation",
    addParticipantsToChatActions,
    req,
    null,
  )

const removeParticipantsFromChat = (req) =>
  _helpers.wsCommand(
    "RemoveParticipantsFromConversation",
    removeParticipantsFromChatActions,
    req,
    null,
  )

const getBlobjectByWrappedKey = (req) =>
  _helpers.wsCommand(
    'GetBlobjectByWrappedKey',
    getBlobjectByWrappedKeyActions,
    req,
    null,
  )

const findReusableConversation = (req) =>
  _helpers.wsCommand(
    'FindReusableConversation',
    findReusableConversationActions,
    req,
    null,
  )

// The Feedback dialog's ticket; see CreateSupportTicket.
const createSupportTicket = (req) =>
  _helpers.wsCommand('CreateSupportTicket', createSupportTicketActions, req, null)

exports. default = {
  getInbox,
  getInboxCounts,
  getInboxForUser,
  getInboxForPatient,
  setTeamInboxSettings,
  renameChat,
  getMe,
  getBlobjectDeep,
  updateChatNotifications,
  createConversation,
  markBlobjectSeen,
  markBlobjectUnread,
  setBlobjectPinned,
  completeBlobject,
  uncompleteBlobject,
  setBlobjectCompletedForTeams,
  createSmsConversation,
  addParticipantsToChat,
  removeParticipantsFromChat,
  getBlobjectByWrappedKey,
  findReusableConversation,
  createSupportTicket,
}
